export default __webpack_public_path__ + "static/media/instagram_icon.cf3e2e56.svg";